import React, { Fragment, Component } from "react";
import './Charts.scss';

import c3 from 'c3';


class SingleLineChart extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderChart = (data) => {
    c3.generate({
      bindto: `#${data.chartId}`,
      interaction: {
        enabled: true
      },
      data: {
        xs: {
          'portfolio': 'x1',
        },
        columns: [
          data.xAxisCategory1,
          data.data1,
        ],
        type: 'spline',
        colors: {
          portfolio: '#14213d',
        }
      },
      // legend: {
      //   position: 'right'
      // },
      legend: {
        show: true,
        position: 'inset',
        inset: {
          anchor: 'top-right',
          x: 80,
          y: 260,
          // step: 5
        }
      },
      axis: {
        x: {
          show: data.isXAxis,
          type: 'timeseries',
          tick: {
            format: '%Y-%b',
            culling: false,
            rotate: 70,
          }
        },
        y: { show: data.isYAxis }
      }
    });
  }

  componentDidMount() {
    this.renderChart(this.props);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.chartData !== this.props.chartData) {
      this.renderChart(this.props);
    }
  }


  render() {
    const { chartId } = this.props;
    return (
      <Fragment>
        <div id={chartId}></div>
      </Fragment>
    );
  }
}

export default SingleLineChart;
